<template>
  <div>
    <MeterViewDiagram ref="MeterViewDiagram" v-if="excel_list2.length>0" :is-editor="true" :excel_list="excel_list2" @onLoad="onLoad" @onClickMeter="onClickMeter"/>
  </div>
</template>

<script>
import MeterViewDiagram from "./MeterViewDiagram";
import MeterHttp from "../../../common/MeterHttp";
export default {
  name: "MeterMapEditor",
  inject:['mainObj','componentId','setComponentId'],
  components: {MeterViewDiagram},
  props:{
    meterId:[Number,String]
  },
  data(){
    return{
      meter_id:null,
      excel_list2:[],
    }
  },
  mounted() {
    const that=this;
    let meter_id=that.meterId||that.$route.query.meterId||that.mainObj.map_id;
    that.meter_id=meter_id;
    that.onLoad();
  },
  methods:{
    show(meter_id,callback){
      const that=this;
      that.meter_id=meter_id;
      that.onLoad(callback);
    },
    onClose(){

    },
    onLoad(callback){
      const that=this;
      MeterHttp.post("Meter/getMapTree?user_type="+(that.$route.query.type||0),{
        project_id:that.mainObj.project_id,
        meter_id:that.meter_id,
      },ret=>{
        if(ret.code){
          that.excel_list2=ret.data;
          that.dialogVisible=true;
        }else {
          that.$message.error(ret.msg||"数据异常")
        }
        typeof callback==="function"&&callback(ret)
      })
    },
    download(){
      this.$refs.MeterViewDiagram.download();
    },
    onClickMeter(node){
      const that=this;
      that.show(node.id,function () {
        setTimeout(function () {
          that.$refs.MeterViewDiagram.reData()
        },500)
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.dialog-1{
  >>>.el-dialog__body{
    padding: 0;
  }
  >>>.el-dialog__header{
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/MeterMapEditor.vue